import React, { useEffect, useState } from "react";
import { SortableTree, SimpleTreeItemWrapper } from "dnd-kit-sortable-tree";
import minusIcon from "../assets/minus-circle.svg";
import editIcon from "../assets/pen1.svg";

export default function DataSortableTree({
  allIteams,
  setAllItems,
  onEditItem,
  onRemoveItem,
}) {
  return (
    <SortableTree
      items={convertToTreeItems(allIteams)}
      onItemsChanged={(updatedItems) => {
        setAllItems(assignOrder(updatedItems)); // send back to parent
      }}
      TreeItemComponent={(props) => (
        <TreeItem {...props} onEdit={onEditItem} onRemove={onRemoveItem} />
      )}
    />
  );
}

const TreeItem = React.forwardRef((props, ref) => {
  const { item, onEdit, onRemove } = props;

  return (
    <SimpleTreeItemWrapper {...props} ref={ref} indicator>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div>{item.value}</div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className="btn-link me-2"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(item);
            }}
            onPointerDown={(e) => e.stopPropagation()}
          >
            <img src={editIcon} alt="edit" style={{ width: 16, height: 16 }} />
          </button>

          <button
            className="btn-link text-danger"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(item.id);
            }}
            onPointerDown={(e) => e.stopPropagation()}
          >
            <img
              src={minusIcon}
              alt="remove"
              style={{ width: 16, height: 16 }}
            />
          </button>
        </div>
      </div>
    </SimpleTreeItemWrapper>
  );
});

/* Convert only API data to the required format */
function convertToTreeItems(data) {
  return data.map((item) => ({
    ...item,
    id: item._id ?? item.page_id ?? item.id,
    value: item.name,
    children: item.children?.length ? convertToTreeItems(item.children) : [],
  }));
}

function assignOrder(items, isSubMenu = false) {
  return items.map((item, index) => ({
    ...item,
    order: index + 1, // or index if you prefer 0-based
    menu_id: isSubMenu ? item.parentId : null,
    children: item.children?.length ? assignOrder(item.children, true) : [],
  }));
}
